"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseSize = void 0;
var defaultPrecisionMap = {
    bytes: 0,
    KB: 0,
    MB: 1,
    GB: 1,
    TB: 2,
    PB: 2
};
/*
 * Convert bytes into largest possible unit.
 * Takes an precision argument that can be a number or a map for each unit.
 */
function parseSize(bytes, precision) {
    if (bytes === void 0) { bytes = 0; }
    if (precision === void 0) { precision = defaultPrecisionMap; }
    var units = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB'];
    if (isNaN(parseFloat(String(bytes))) || !isFinite(bytes)) {
        return '?';
    }
    var unitIndex = 0;
    while (bytes >= 1024) {
        bytes /= 1024;
        unitIndex++;
    }
    var unit = units[unitIndex];
    if (typeof precision === 'number') {
        return bytes.toFixed(precision) + " " + unit;
    }
    return bytes.toFixed(precision[unit]) + " " + unit;
}
exports.parseSize = parseSize;
